import type {
  ProjectSettings,
  PublishedSite,
  SetCheckoutProviderInput,
  TransferProjectInput,
  UpdateProjectSettingsInput,
} from "schemas/generated/bedrock";
import type { RequestFn } from "./request";

export function createProjectsClient({ request }: { request: RequestFn }) {
  return {
    getPublishedSite: ({
      projectId,
      siteId,
    }: {
      projectId: string;
      siteId: string;
    }) => {
      return request<PublishedSite>({
        method: "GET",
        path: `/api/v1/projects/${projectId}/published-site`,
        query: { siteId },
      });
    },
    get: ({ projectId }: { projectId: string }) => {
      return request<ProjectSettings>({
        method: "GET",
        path: `/api/v1/projects/${projectId}`,
      });
    },
    update: ({
      projectId,
      ...input
    }: { projectId: string } & UpdateProjectSettingsInput) => {
      return request<ProjectSettings>({
        method: "PATCH",
        path: `/api/v1/projects/${projectId}`,
        body: input,
      });
    },
    setCheckoutProvider: ({
      projectId,
      ...input
    }: { projectId: string } & SetCheckoutProviderInput) => {
      return request<ProjectSettings>({
        method: "PATCH",
        path: `/api/v1/projects/${projectId}/checkout-provider`,
        body: input,
      });
    },
    transfer: ({
      projectId,
      ...input
    }: { projectId: string } & TransferProjectInput) => {
      return request<ProjectSettings>({
        method: "POST",
        path: `/api/v1/projects/${projectId}/transfer`,
        body: input,
      });
    },
    delete: ({ projectId }: { projectId: string }) => {
      return request<{ success: boolean; availableProjectId: string | null }>({
        method: "DELETE",
        path: `/api/v1/projects/${projectId}`,
      });
    },
  };
}
